import { LocaleProvider } from "./LocaleProvider.jsx";
import { CurrencyProvider } from "./CurrencyProvider.jsx";

export function IntlProvider({
  surface = "platform",
  manifest = null,
  accountPreferences = null,
  urlLocale = null,
  children,
}) {
  return (
    <LocaleProvider
      surface={surface}
      manifest={manifest}
      accountPreferences={accountPreferences}
      urlLocale={urlLocale}
    >
      <CurrencyProvider accountPreferences={accountPreferences} manifest={manifest}>
        {children}
      </CurrencyProvider>
    </LocaleProvider>
  );
}

export default IntlProvider;
